import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<circle cx=\"50\" cy=\"50\" r=\"50\" fill=\"url(#paint0_linear_2002_83821)\"></circle><path d=\"M55.0917 28.334H44.9083C42.655 28.334 40.8133 30.154 40.8133 32.4073V34.444C40.8133 36.6973 42.6333 38.5173 44.8867 38.5173H55.0917C57.345 38.5173 59.165 36.6973 59.165 34.444V32.4073C59.1867 30.154 57.345 28.334 55.0917 28.334Z\" fill=\"white\"></path><path d=\"M61.3533 34.4416C61.3533 37.8866 58.5366 40.7032 55.0916 40.7032H44.9083C41.4633 40.7032 38.6466 37.8866 38.6466 34.4416C38.6466 33.2282 37.3466 32.4699 36.2633 33.0332C33.2083 34.6582 31.1283 37.8866 31.1283 41.5916V61.9799C31.1283 67.3099 35.4833 71.6649 40.8133 71.6649H59.1866C64.5166 71.6649 68.8716 67.3099 68.8716 61.9799V41.5916C68.8716 37.8866 66.7916 34.6582 63.7366 33.0332C62.6533 32.4699 61.3533 33.2282 61.3533 34.4416ZM55.4816 60.1599C55.1566 60.4849 54.745 60.6366 54.3333 60.6366C53.9216 60.6366 53.51 60.4849 53.185 60.1599L50.0433 57.0182L46.815 60.2466C46.49 60.5716 46.0783 60.7232 45.6666 60.7232C45.255 60.7232 44.8433 60.5716 44.5183 60.2466C43.89 59.6182 43.89 58.5782 44.5183 57.9499L47.7466 54.7216L44.605 51.5799C43.9766 50.9516 43.9766 49.9116 44.605 49.2832C45.2333 48.6549 46.2733 48.6549 46.9016 49.2832L50.0433 52.4249L53.0766 49.3916C53.705 48.7632 54.745 48.7632 55.3733 49.3916C56.0016 50.0199 56.0016 51.0599 55.3733 51.6882L52.34 54.7216L55.4816 57.8632C56.11 58.4916 56.11 59.5099 55.4816 60.1599Z\" fill=\"white\"></path><defs><linearGradient id=\"paint0_linear_2002_83821\" x1=\"45\" y1=\"45\" x2=\"107.692\" y2=\"116.704\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#17CF97\"></stop><stop offset=\"1\" stop-color=\"#A9F1D2\"></stop></linearGradient></defs>", 4)
const _hoisted_6 = [
  _hoisted_2
]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteGoalIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
}

})